import { render, staticRenderFns } from "./CheckDiscountOrder.vue?vue&type=template&id=2e6f3aa7&scoped=true&"
import script from "./CheckDiscountOrder.vue?vue&type=script&lang=js&"
export * from "./CheckDiscountOrder.vue?vue&type=script&lang=js&"
import style0 from "./CheckDiscountOrder.vue?vue&type=style&index=0&id=2e6f3aa7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6f3aa7",
  null
  
)

export default component.exports